<template>
    <div class="app" >
        <div class="mask" @click="hiddenAlarm($event)" v-show="$store.state.showAlarm" ></div>
        <div class="bg" ></div>
        <div class="head">
            <div class="name">{{ projectName }}</div>
        </div>
        <div class="basicInfo">
            <div class="tem">
                <div >{{ weather }}</div>
                <div>{{ temperature }}<span>℃</span></div>
            </div>
            <div class="hum">
                <div>湿:</div> 
                <div>{{ humidity }}<span>%</span></div>
            </div>
            <div class="exit" @click="exit" ref="exit">
                <div class="icon"></div>
                <div class="list" v-show="isExit" >
                    <SelectList :selectList="seletList" @tabTitle="tabSelect" keyk="sed" keyval="value" />
                </div>
            </div>
        </div>
        <div class="type">
            <div :class="$store.state.currentPage == 1?'tabType': 'tabTypeS'" @click="pageTab(1)">
                总览
            </div>
            <div :class="$store.state.currentPage == 2?'tabType': 'tabTypeS'" @click="pageTab(2)">
                变配电
            </div>
            <div :class="$store.state.currentPage == 3?'tabType': 'tabTypeS'" @click="pageTab(3)">
                微电网 
            </div>
            <div :class="$store.state.currentPage == 0?'ban': $store.state.showAlarm?'tabType': 'tabTypeS'"  @click="showAlarms()" ref="alarm">
                报警({{$store.state.alarmNum}})
            </div>
        </div>
        <div class="time">
            <p>{{ time.substr(0,11) }}</p>
            <p>{{ time.substr(11) }}</p>
        </div>
        <router-view :key="$route.name + ($route.params.id || '')"></router-view>
        <ParkOverView />
    </div>
</template>

<script>
const ParkOverView = () => import('./components/ParkOverView.vue')
const SelectList = () => import('../components/title/selectList.vue')

    import {
        GetBaseInfo,
        GetAllLoopsByProjectId,
        GetTransformerNum,
        GetAllAreas,
        GetAllSecurity,
        GetLoopMaster,
        GetLoadInfo,
        getCapacity
    } from "@/components/Request";
    import {
        subscribebySubLoopUrl
    } from "@/mqtt/index"

    export default {
        name: "App",
        data() {
            return {
                isExit:false,
                cut:'',
                seletList:[
                    {
                        sed:1,
                        value:'返回工作台'
                    },
                    {
                        sed:2,
                        value:'返回数据驾驶舱'
                    },
                ],
//------------------------------------------------------新版本旧版本改动分界
                weather: "",
                temperature: "--",
                humidity: "--",
                time: "",
                projectName: "",
                projectIcon: "",
                projectCoordinate: ''
            };
        },
        components:{
            ParkOverView,SelectList
        },
        created() {
            GetAllAreas({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        allThreeUrl: data.data.areas
                    })
                    let surveillance = []
                    new Promise((resolve) => {
                        data.data.areas.forEach(item => {
                            GetAllSecurity({
                                areaId: item.areaId
                            }).then(({
                                data
                            }) => {
                                surveillance.push({
                                    areaId: item.areaId,
                                    rooms: {
                                        types: ["监控列表", "门禁列表"],
                                        details: [
                                            data.data.devices.filter(item =>
                                                item.device_class_name ==
                                                '监控设备'
                                            ),
                                            [],
                                        ],
                                    },
                                })
                            })
                        })
                        resolve()
                    }).then(() => {
                        this.$store.commit("set_val", {
                            surveillance: surveillance
                        })
                    })
                }),
                GetLoopMaster({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        loopMaster: data.data.loops
                    })
                    data.data.loops.forEach(item => {
                        subscribebySubLoopUrl([
                            item.subLoopUrl + '/P',
                        ])
                    })
                })
        },
        computed:{
            currentDate(){
                return this.time.substr(0,11)
            },
            currentTime(){
                return this.time.substr(11)
            }
        },
        mounted() {
            this.getPage()
            this.$store.dispatch('actionsAllAreas')


            window.addEventListener("message", this.handleMessage);
            // 区域总览信息
            GetBaseInfo({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                // this.projectName = data.data.project.projectName
                this.projectName = "智慧园区运维管理平台"
                this.projectIcon = data.data.project.projectIcon
                this.projectCoordinate = data.data.project.projectCoordinate
                this.$store.commit("set_val", {
                    // receivingCapacity: JSON.parse(data.data.project.projectDetailsInfo)['受电容量'],
                    voltageClass: JSON.parse(data.data.project.projectDetailsInfo)['供电电压']
                });
                this.getWeatherInfo(this.projectCoordinate)
            })

            // 动态时间显示
            setInterval(() => {
                this.time = this.dateFormat("YYYY年mm月dd日 HH:MM:SS", new Date());
            }, 1000);

            this.getLoadInfo()

            setInterval(() => {
                this.getWeatherInfo(this.projectCoordinate)
                this.getLoadInfo()
            }, 10 * 60 * 1000);

            // 获取当前项目变压器数量
            GetTransformerNum({
                projectId: this.$store.state.projectId,
            }).then(({
                data
            }) => {
                let datas = data.data.result
                if (datas && datas.find(item => item.type == '变压设备'))
                    this.$store.commit("set_val", {
                        transformerNum: datas.find(item => item.type == '变压设备').num
                    })
            }).catch(err => {
                console.log(err)
            })

            getCapacity({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        receivingCapacity: data.data.res
                    });
                })


            

        },
        methods: {
            exit() {
                console.log(this.cut);  // 用于判断当前地址，后台进入有列表返回 ，前台进入直接返回
                // if(this.cut == 'all'){
                    window.parent.postMessage({
                        cmd: 'exit',
                    }, '*');
                // }else{
                //     this.isExit = !this.isExit
                // }
                
            },
            tabSelect(value){
                this.isExit = false
                if(value.sed == 1){
                    // console.log('在这里返回工作台');
                    // console.log(this.cut);
                    window.location.href = `http://www.energydt.cn:38080/ebs-ch/#/login?${this.cut}`
                    console.log(window);
                    

                }else{
                    // console.log('在这里返回驾驶舱');
                    window.parent.postMessage({
                        cmd: 'exit',
                    }, '*');
                }
            },
            getPage(){
                let page = window.location.href.split('?')
                this.cut = page[page.length - 1]
                console.log(this.cut);
            },
            pageTab(page){
                this.$store.commit('set_page',page)
                this.$router.push('/overview')

                // 切换时重置用电的分布按钮
                this.$store.commit('set_electricityFlag',true)

            },
            showAlarms(){
                if(this.$store.state.currentPage== 0){
                    return 
                }else{
                    this.$store.commit('set_showAlarm',!this.$store.state.showAlarm)
                }
            },
            dateFormat(fmt, date) {
                let ret;
                const opt = {
                    "Y+": date.getFullYear().toString(), // 年
                    "m+": (date.getMonth() + 1).toString(), // 月
                    "d+": date.getDate().toString(), // 日
                    "H+": date.getHours().toString(), // 时
                    "M+": date.getMinutes().toString(), // 分
                    "S+": date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                    ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
                    }
                }
                return fmt;
            },
            getLoadInfo() {
                GetLoadInfo({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    // this.$store.commit("set_val", {
                    //     load: data.data.influxData.load
                    // });
                })
            },
            getWeatherInfo(location) {
                // 天气信息
                // 420114 蔡甸区 昌华/凯骏
                // 420111 洪山区 留创园
                // 370827 鱼台县 鲁泰
                let id = 420111
                // // 高德api 100000/天 无法通过经纬度查询
                // fetch("https://restapi.amap.com/v3/weather/weatherInfo?city=" + id + "&key=3ecd07184027ff3342dc5f24551c2ecc")
                //     .then((response) => response.json())
                //     .then((json) => {
                //         const {
                //             temperature,
                //             weather,
                //             humidity
                //         } = json.lives[0];
                //         this.temperature = temperature;
                //         this.weather = weather;
                //         this.humidity = humidity;
                //     }).catch((e) => {
                //         return e;
                //     });

                // 和风天气api 10000/天 可通过经纬度查询
                fetch('https://devapi.heweather.net/v7/weather/now?location=' + location +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63')
                    .then(response => response.json())
                    .then(json => {
                        this.temperature = json.now.temp;
                        this.weather = json.now.text;
                        this.humidity = json.now.humidity;

                        // 存储天气用来昌华演示的假数据，如果数据接通，可删除 
                        this.$store.commit('Cang/setWeather','空')

                        this.$store.commit('Cang/setWeather',json.now.text)
                    })
            },
            
            handleMessage(event) {
                // console.log(event);
                const data = event.data;
                switch (data.cmd) {
                    case "loadEnd":
                        window.parent.postMessage({
                            cmd: 'loadEnd',
                        }, '*');
                        break;
                    case "loadProgress":
                        // console.log(data.value);
                        window.parent.postMessage({
                            cmd: 'loadProgress',
                            value: data.value
                        }, '*');
                        break;
                }
            },
            quchong4(str) {
                var obj = {};
                var newStr = "";
                for (var i = 0; i < str.length; i++) {
                    if (!obj[str[i]]) {
                        newStr += str[i];
                        obj[str[i]] = 1;
                    }
                }
                return newStr;
            },
            hiddenAlarm(e){
                let alarm = this.$refs.alarm
                if(alarm && !alarm.contains(e.target)){
                    this.showAlarm = false
                    this.$store.commit('set_showAlarm',false)
                }

                let exit = this.$refs.exit
                if(exit && !exit.contains(e.target)){
                    this.isExit = false
                }
            },
            
        },
    };
</script>

<style lang="less" scoped>
    .app {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        .mask{
            width: 100vw;
            height: 100vh;
            position: fixed;
            left: 0;
            top: 0;
        }
    }

    .bg {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url("../assets/img/背景.png");
        background-size: 100% 100%;
        clip-path: polygon(0 0, 100% 0, 100% 12%, 12% 12%, 12% 88%, 88% 88%, 88% 12%, 100% 12%, 100% 100%, 0 100%, 0 0);
        z-index: 0;
    }

    .head {
        width: 6300/192vw;
        height: 7.8vh;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;

        .name {
            font-family: YouSheBiaoTiHei;
            color: #e6f3fd;
            font-size: 36rem;
            margin-left: 7vw;
        }
    }

    .basicInfo {
        height: 6vh;
        position: fixed;
        top: 0vh;
        right: 1vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-family: zcoolqingkehuangyouti;
        color: #e6f3fdff;
        z-index: 11;
    }

    .tem,
    .hum {
        width: 1000/192vw;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        
    }
    .tem{
        font-size: 26rem;
        align-items: end;
        margin-right: 0.5vw;
        div:nth-child(1){
            font-family: Source Han Sans CN;
            white-space: nowrap;
        }
        div:nth-child(2){
            font-family: zcoolqingkehuangyouti;
            span{
                font-size: 18rem;
            }
        }
    }
    .hum{
        align-items: center;
        div:nth-child(1){
            font-family: Source Han Sans CN;
            font-size: 26rem;
        }
        div:nth-child(2){
            font-family: zcoolqingkehuangyouti;
            font-size: 26rem;
            span{
                font-size: 18rem;
            }
        }
    }

    .exit {
        margin-left: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        position: relative;

        .icon {
            .w(24);
            .h(23);
            background: url('../assets/img/离开.png');
            background-size: 100% 100%;
            margin-right: 5px;
        }

        .list{
            position: absolute;
            right: 0vw;
            top: 3vh;
            width: 8vw;
            height: 7.5vh;
            font-family: MicrosoftYaHei;
        }
    }

    .time {
        width: 1830/192vw;
        height: 110/108vh;
        position: fixed;
        right: 11vw;
        top: 1vh;
        font-family: zcoolqingkehuangyouti;
        color: #e6f3fdff;
        white-space: nowrap;
        p:nth-child(1){
            font-size: 16rem;
            letter-spacing: 0.1vw;
        }
        p:nth-child(2){
            font-size: 24rem;
        }
    }


    .type{
        width:17vw;
        height: 4vh;
        line-height: 4vh;
        position: fixed;
        right: 24vw;
        top: 2.9vh;
        color: #fff;
        font-size: 16rem;
        display: flex;
        justify-content: space-between;
        font-family: Source Han Sans CN;
        font-weight: 400;
        
        .tabType{
            position: relative;
            text-align: center;
            cursor: pointer;
            text-shadow: 
                0 0 1vh  rgba(13,148,255, 0.9),
                0 0 2vh  rgba(13,148,255, 0.9),
                0 0 3vh  rgba(13,148,255, 0.9);
        }
        .tabTypeS{
            position: relative;
            text-align: center;
            cursor: pointer;
            text-shadow: 
                0 0 1vh  rgba(13,148,255, 0.9),
                0 0 2vh  rgba(13,148,255, 0.9),
                0 0 3vh  rgba(13,148,255, 0.9);
        }
        .tabType::before{
            content: '';
            width:calc(100% - 3rem) ;
            height: 2rem;
            border: 1rem solid #fff;
            border-radius: 3rem;
            position: absolute;
            background-color: #fff;
            top: 0;
            left: 0;
        }

        .ban{
            color: #ccc;
            cursor: not-allowed;
        }
    }
    
</style>